import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@mui/material'
import clsx from 'clsx'

import { ReactComponent as PlusCircle } from '../../../../assets/icons/plus-circle.svg'
import { ReactComponent as Notepad } from '../../../../assets/icons/notepad.svg'

import useTranslations from '../../../../i18n/useTranslations'

import useStyles from './styles'

const propTypes = {
  children: PropTypes.node,
  addressSource: PropTypes.string,
  changeAddressSource: PropTypes.func,
}

export const ADDRESS_SOURCES = {
  clientCentersList: 'clientCentersList',
  newAddress: 'newAddress',
}

const SourceAddressSelector = ({
  children,
  addressSource,
  changeAddressSource,
}) => {
  const classes = useStyles()
  const formatMessage = useTranslations()

  return (
    <Box component="section" className={classes.section}>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.title)}
      >
        {formatMessage('shipping-send-form:title:origin-address')}
      </Typography>
      <Box mb={3} sx={{ display: 'flex' }}>
        <Button
          size="small"
          startIcon={<Notepad weight="regular" />}
          variant={
            addressSource === ADDRESS_SOURCES.clientCentersList
              ? 'contained'
              : 'outlined'
          }
          onClick={() => changeAddressSource(ADDRESS_SOURCES.clientCentersList)}
        >
          {formatMessage('shipping-send-form:label:existing-address')}
        </Button>
        <Button
          size="small"
          startIcon={<PlusCircle weight="regular" />}
          variant={
            addressSource === ADDRESS_SOURCES.newAddress
              ? 'contained'
              : 'outlined'
          }
          onClick={() => changeAddressSource(ADDRESS_SOURCES.newAddress)}
        >
          {formatMessage('shipping-send-form:label:new-address')}
        </Button>
      </Box>

      {children}
    </Box>
  )
}

SourceAddressSelector.propTypes = propTypes

export default SourceAddressSelector
